import { useState, useEffect } from 'react'

import Api from 'services/api'
import { TableDetail } from 'types/TableDetail'

const useCustomerDetail = (deviceId) => {
  const [customer, setCustomer] = useState<Array<TableDetail> | null>(null)
  const [diagContact, setDiagContact] = useState<Array<TableDetail> | null>(null)
  const [homeContact, setHomeContact] = useState<Array<TableDetail> | null>(null)
  const [diagAddress, setDiagAddress] = useState<Array<TableDetail> | null>(null)
  const [homeAddress, setHomeAddress] = useState<Array<TableDetail> | null>(null)
  const [isCustomerLoaded, setIsCustomerLoaded] = useState(false)

  useEffect(() => {
    setCustomer(null)
    setDiagContact(null)
    setHomeContact(null)
    setDiagAddress(null)
    setHomeAddress(null)
    setIsCustomerLoaded(false)

    Api.DeviceAggregator.getCustomer(deviceId)
      .then((res) => {
        if (res) {
          const { customer, diagContact, homeContact, diagAddress, homeAddress } = res

          setIsCustomerLoaded(true)
          setCustomer(customer)
          setDiagContact(diagContact)
          setHomeContact(homeContact)
          setDiagAddress(diagAddress)
          setHomeAddress(homeAddress)
        }
      })
      .catch(() => {
        setIsCustomerLoaded(true)
      })
  }, [deviceId])

  return { customer, diagContact, homeContact, diagAddress, homeAddress, isCustomerLoaded }
}

export default useCustomerDetail
